// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 186 ? "viwes-gogo" : chunkId) + "." + {"186":"95afea70","544":"d4139ab1","998":"7bb717bd"}[chunkId] + ".chunk.css";
};